import { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Container, Row, Col, Button } from "react-bootstrap";

import api from "../../services/api";
import Template from "../../template";
import { toast } from "react-toastify";

import CarregarPDFAluno from '../../components/CarregarPDFAluno/';

import * as S from "./styled";

function UploadRedacoesUERJ(props) {
  const { id_redacao, redacao } = props.match.params;

  const { isDragReject } = useDropzone({
    accept: "application/pdf",
  });

  const [arquivo, setArquivo] = useState("");
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [enviando, setEnviando] = useState(false);


  async function sendFile(file) {
    if (!file) {
      toast.error("Nenhum arquivo selecionado");
      return;
    }

    setEnviando(true);
    const data = new FormData();

    data.append("id_redacao", id_redacao);
    data.append("file", file);

    try {
      const retorno = await api.patch("/envio", data);

      toast.success("Redação enviada com sucesso!");
      // Definir arquivo para mostrar tela de sucesso
      setArquivo("enviado_com_sucesso");
      setArquivoSelecionado(null);
      setPreviewUrl("");
      
      // Opcional: redirecionar para página de correção após sucesso
      // history.push(`/correcao/${id_redacao}`);
    } catch (error) {
      toast.error("Erro ao enviar redação");
      console.error(error);
    } finally {
      setEnviando(false);
    }
  }

  function cancelarSelecao() {
    setArquivoSelecionado(null);
    setPreviewUrl("");
    toast.info("Seleção cancelada");
  }

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0] === undefined) {
      toast.error("Tipo de arquivo invalido");
      return false;
    }

    const file = acceptedFiles[0];
    
    // Verificar se o arquivo é maior que 10MB (10 * 1024 * 1024 bytes)
    const maxSize = 10 * 1024 * 1024; // 10MB em bytes
    if (file.size > maxSize) {
      toast.error("O arquivo deve ter no máximo 10MB");
      return false;
    }

    // Criar preview do arquivo
    const fileUrl = URL.createObjectURL(file);
    setPreviewUrl(fileUrl);
    setArquivoSelecionado(file);
    
    toast.success("Arquivo selecionado! Clique em 'Enviar' para confirmar.");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function getPDF() {
      try {
        const { data } = await api.get(`/getRedacao/${id_redacao}`);

        setArquivo(data[0].pdf);
      } catch (error) {}
    }

    if (redacao === "redacao") {
      getPDF();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "application/pdf",
  });

  return (
    <Template>
      <S.MainWrapper>
        <Container>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                <Row>
                  <Col>
                    <legend>
                      <strong>Enviar Redação</strong>
                    </legend>
                    <p className="text-muted">
                      Envie sua redação em formato PDF. Ela será processada e ficará disponível para correção.
                    </p>
                  </Col>
                </Row>

                <Row>
                  {arquivo ? (
                    <>
                      <Col>
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                          <h4 style={{ color: '#28a745', marginBottom: '20px' }}>
                            ✅ Redação Enviada com Sucesso!
                          </h4>
                          <p style={{ fontSize: '16px', marginBottom: '30px' }}>
                            Sua redação foi enviada e está sendo corrigida pelos corretores.
                          </p>
                          <Button
                            variant="primary"
                            size="lg"
                            onClick={async () => {
                              try {
                                // Buscar dados da redação para obter o classe_id
                                const response = await api.get(`/redacao/uerj/${id_redacao}`);
                                const classeId = response.data.redacao.classe_id;
                                
                                // Redirecionar para a página da classe
                                props.history.push(`/minhaclasse/${classeId}`);
                              } catch (error) {
                                console.error('Erro ao buscar dados da redação:', error);
                                // Fallback: redirecionar para redações UERJ
                                props.history.push("/redacoes-uerj");
                              }
                            }}
                          >
                            Ver minhas redações
                          </Button>
                        </div>
                      </Col>
                    </>
                  ) : (
                    <Col>
                      {/* Área de seleção de arquivo estilizada */}
                      <div 
                        {...getRootProps({ className: "dropzone" })}
                        style={{
                          border: '2px dashed #007bff',
                          borderRadius: '8px',
                          padding: '40px 20px',
                          textAlign: 'center',
                          backgroundColor: '#f8f9fa',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          ...(isDragActive && {
                            backgroundColor: '#e9ecef',
                            borderColor: '#0056b3'
                          }),
                          ...(isDragReject && {
                            backgroundColor: '#f8d7da',
                            borderColor: '#dc3545'
                          })
                        }}
                        onMouseEnter={(e) => {
                          if (!isDragActive && !isDragReject) {
                            e.target.style.backgroundColor = '#e9ecef';
                            e.target.style.borderColor = '#0056b3';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isDragActive && !isDragReject) {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.borderColor = '#007bff';
                          }
                        }}
                      >
                        <input
                          name="file"
                          accept="application/pdf"
                          {...getInputProps()}
                        />
                        <div>
                          {isDragActive ? (
                            <>
                              <p><strong>📄 Solte o arquivo PDF aqui...</strong></p>
                              <p className="text-muted">Processando arquivo...</p>
                            </>
                          ) : isDragReject ? (
                            <>
                              <p><strong>❌ Tipo de arquivo não suportado</strong></p>
                              <p className="text-danger">Apenas arquivos PDF são aceitos</p>
                            </>
                          ) : (
                            <>
                              <p><strong>📄 Clique aqui ou arraste sua redação em PDF</strong></p>
                              <p className="text-muted">Apenas PDF • Máximo 10MB</p>
                              {arquivoSelecionado && (
                                <p className="text-success">
                                  <small>✅ Arquivo selecionado: {arquivoSelecionado.name}</small>
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>

                {/* Seção de preview e controles quando um arquivo é selecionado */}
                {arquivoSelecionado && (
                  <Row className="mt-4">
                    <Col>
                      <div style={{ 
                        border: '2px solid #007bff', 
                        borderRadius: '8px', 
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                          <h5 className="mb-3">📄 Preview da Redação</h5>
                          <p><strong>{arquivoSelecionado.name}</strong></p>
                          <p className="text-muted">Tamanho: {(arquivoSelecionado.size / 1024 / 1024).toFixed(2)} MB</p>
                        </div>
                        
                        {/* Preview do PDF - apenas a redação */}
                        <div style={{ 
                          width: '100%', 
                          height: '600px', 
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          marginBottom: '20px',
                          backgroundColor: '#fff',
                          overflow: 'hidden'
                        }}>
                          <iframe
                            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                            width="100%"
                            height="100%"
                            style={{ 
                              border: 'none', 
                              borderRadius: '4px',
                              transform: 'scale(1)',
                              transformOrigin: 'top left'
                            }}
                            title="Preview da Redação"
                          />
                        </div>
                        
                        <div style={{ textAlign: 'center' }}>
                          <Button 
                            variant="success" 
                            onClick={() => sendFile(arquivoSelecionado)}
                            disabled={enviando}
                            className="me-4"
                            size="lg"
                          >
                            {enviando ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Enviando...
                              </>
                            ) : (
                              'Confirmar e Enviar Redação'
                            )}
                          </Button>
                          
                          <Button 
                            variant="outline-secondary" 
                            onClick={cancelarSelecao}
                            disabled={enviando}
                            size="lg"
                            style={{ marginLeft: '30px' }}
                          >
                            Escolher Outro Arquivo
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
      </Template>
    );
  }

export default UploadRedacoesUERJ;